<template>
  <div>
    <h1 class="mb-30">Интеграция с AmoCRM</h1>

    <Spinner v-if="isLoading" />
    <div v-else class="wrap-form mb-40">
      <VForm @request="onRequest" v-model="formData" class="box">
        <div class="form form-integration column gap-s mb-30">
          <VInput
            type="textarea"
            label="Токен:"
            name="access_token"
            tooltip="Генерируется в AmoCRM → amoМаркет → Установленные → Открываем интеграцию с порталом ERP → Ключи и доступы → Долгосрочный токен → Сгенерировать → Сохранить и полученный токен вставить в это окно"
          />

          <VInputDate
            ref="VInputDate"
            label="Дата истечения:"
            :value="formData.deadline"
            is-single
            tooltip="Носит информативный характер, указывается при генерации токена"
          />
        </div>
        <div class="buttons">
          <VButton
            text="Сохранить"
            color="primary"
            size="xl"
            type="submit"
            :loading="isLoadingForSet"
          />
          <VButton
            text="Отмена"
            size="xl"
            @click.native="goToPrevPage"
          />
        </div>
      </VForm>
    </div>
  </div>
</template>

<script>
import VForm from '@/components/Form/VForm.vue'
import VInput from '@/components/Form/Vinput/VInput.vue'
import VInputDate from '@/components/Form/VInputDate.vue'
import { mapActions, mapGetters } from 'vuex'
import VButton from '@/components/simple/button/VButton.vue'
import { goToPrevPage } from '@/utils/router'

export default {
  name: 'SettingsIntegrationAmoCrm',
  components: { VButton, VInputDate, VInput, VForm },

  data () {
    return {
      formData: {
        access_token: null,
        deadline: null
      }
    }
  },

  async mounted () {
    await this.getToken()
  },

  watch: {
    tokens: {
      handler (newTokens) {
        if (newTokens && Object.keys(newTokens).length > 0) {
          this.formData = {
            access_token: newTokens.access_token || null,
            deadline: newTokens.deadline || null
          }

          if (newTokens.deadline && this.$refs.VInputDate?.$refs?.dateRef) {
            this.$refs.VInputDate.$refs.dateRef._flatpickr.setDate(newTokens.deadline)
          }
        }
      },
      immediate: true
    }
  },

  computed: {
    ...mapGetters('adminPanel/settings/integrationAmoCrm', {
      tokens: 'tokens',
      isLoading: 'isLoading',
      isLoadingForSet: 'isLoadingForSet'
    })
  },

  methods: {
    ...mapActions('adminPanel/settings/integrationAmoCrm', {
      getToken: 'getToken',
      setToken: 'setToken'
    }),
    goToPrevPage,

    async onRequest (data) {
      try {
        this.$store.commit('SET_IS_SENDING_REQUEST_MODAL')

        const params = {
          access_token: data.access_token,
          deadline: this.$refs.VInputDate.$refs.dateRef?.defaultValue
        }

        await this.setToken(params)
      } finally {
        this.$store.commit('SET_IS_SENDING_REQUEST_MODAL', false)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.form-integration {
  max-width: 50%;

  @media screen and (max-width: $tablet-width-s) {
    max-width: 100%;
  }

  &::v-deep textarea {
    height: 250px;
  }
}
</style>
